// EXPORT-CORE: the in-memory `companies.export` (contracts api/company-export.ts). Owners only;
// the password must be given (the fake takes any but "wrong"); a person with two-step sign-in
// also gives a six-digit code. Answers a small zip-typed file standing in for the archive.
import type { RouteId } from "@companyos/sdk";
import { type Handler, notFound, problem } from "./fake";

export const FAKE_COMPANY_EXPORT_ROUTES = [
  "companies.export",
] as const satisfies readonly RouteId[];

/** The four-byte zip signature and an empty end-of-central-directory record: a valid empty zip. */
const EMPTY_ZIP = new Uint8Array([
  0x50, 0x4b, 0x05, 0x06, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]);

export function createCompanyExportHandlers(): Partial<Record<RouteId, Handler>> {
  return {
    "companies.export": ({ principal: p, body }) => {
      if (!p) return notFound();
      if (!p.roles.includes("owner"))
        return problem(403, "forbidden", "Forbidden", "only an owner exports the company");
      const b = (body ?? {}) as { password?: string; totp_code?: string };
      if (p.me.mfa?.enrolled && !/^\d{6}$/.test(b.totp_code ?? ""))
        return problem(403, "mfa_code_required", "A current two-factor code is needed");
      if (!b.password || b.password === "wrong")
        return problem(403, "reauth_required", "Confirm your password to continue");
      const day = new Date().toISOString().slice(0, 10);
      return new Response(EMPTY_ZIP, {
        status: 200,
        headers: {
          "content-type": "application/zip",
          "content-disposition": `attachment; filename="companyos-archive-${p.company.slug}-${day}.zip"`,
        },
      });
    },
  };
}
